import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { DEPARTMENTS } from "@/data/departments";

export const ZonesSection = () => (
  <section className="py-16 bg-slate-50" data-testid="zones-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-2xl md:text-3xl font-heading font-bold text-slate-900">Nos zones d'intervention</h2>
      <p className="mt-3 text-slate-600 max-w-2xl">Agence à Saint-Denis (93), conseillers disponibles dans toute l'Île-de-France et en Guadeloupe.</p>
      <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {DEPARTMENTS.map((d) => (
          <Link key={d.code} to={`/${d.slug}`} data-testid={`zone-link-${d.code}`}
            className="flex items-center gap-2 rounded-xl bg-white border border-slate-200 px-4 py-4 hover:border-[#102692] transition-colors">
            <MapPin className="w-4 h-4 text-[#F97316] shrink-0" />
            <span className="text-sm font-medium text-slate-800">{d.name} ({d.code})</span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);
